import { IRegions } from '@/common/models/IRegions';
import { request } from '@/services/api/requests';
import { ENDPOINTS } from '@/services/endpoints';
import { useQuery } from '@tanstack/react-query';

export const useRegion = () => {
  return useQuery({
    queryKey: ['regions'],
    queryFn: () => request<IRegions[]>(ENDPOINTS.GET_REGIONS),
    select: (response) =>
      response?.data?.map(({ name_uz, ...rest }) => ({
        value: String(rest.code),
        label: name_uz,
        ...rest,
      })),
  });
};
